export enum UserCreateUpdateActionTypes {
  Init = '[UserCreateUpdate Page] Init',
  InitCreate = '[UserCreateUpdate Page] Init Create',
  InitUpdate = '[UserCreateUpdate Page] Init Update',
  Add = '[UserCreateUpdate/Page] Add User]',
  Update = '[UserCreateUpdate/Page] Update User]',
  Destroyed = '[UserCreateUpdate Page] Destroyed]',
}

export enum UserListActionTypes {
  Init = '[UserList Page] Init',
  ViewMoreClicked = '[UserList Page] View More Clicked',
  ListViewTypeChanged = '[UserList Page] List View Type Changed',
  FiltersChanged = '[UserList Page] Filters Changed',
}

export enum UserDetailsActionTypes {
  Init = '[UserDetails Page] Init',
  UserEnabled = '[UserDetails Page] User Enabled',
  UserDeleted = '[UserDetails Page] User Deleted',
  Destroyed = '[UserDetails Page] Destroyed]',
}
